module.exports = __webpack_public_path__ + "static/media/optimization.d430dc1e.jpg";